import { render, staticRenderFns } from "./CampaignReview.vue?vue&type=template&id=3a104736&"
import script from "./CampaignReview.vue?vue&type=script&lang=ts&"
export * from "./CampaignReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports